import React from 'react';
import { Link } from 'gatsby';
import Container from 'container';
import Headline from 'headline';
import InfluencerCard from 'shared/person-card';
import Img from 'img';

import s from './article_intro_1.module.scss';

function ArticleIntro1({
  title,
  image,
  person_card,
  description,
}) {
  return (
    <Container className={s.root}>
      <Headline h2 title html={title} />
      <div className={s.contentWrapper}>
        <div className={s.cardWrapper}>
          <InfluencerCard {...person_card} />
        </div>
        <div className={s.description} dangerouslySetInnerHTML={{ __html: description }} />
        <div className={s.imgWrapper}>
          <Img effect src={image || 'placeholder-dark'} className={s.img} />
        </div>
      </div>
    </Container>
  );
}
export default ArticleIntro1;
